export default __webpack_public_path__ + "static/media/beach.15cb8ac7.webm";